import { useNavigate } from 'react-router-dom';
import { MoldOrder } from '../../types/mold';
import { CheckCircle, ClipboardList } from 'lucide-react';

const FillQuestionnaireButton: React.FC<{
  moldOrder: MoldOrder;
  progress: { percentage: number | string; answeredQuestions: number; unansweredQuestions: number; totalQuestions: number };
  navigate: ReturnType<typeof useNavigate>;
}> = ({ moldOrder, progress, navigate }) => {
  const percentage = progress.percentage ? Number(progress.percentage).toFixed(0) : '';
  const suffixString = progress.percentage ? `(${percentage}% เสร็จสิ้น)` : '';
  const borderColor = percentage === '100' ? 'border-green-500 text-green-500' : 'border-blue-500 text-blue-500';
  return (
    <button
      onClick={() => navigate(`/questionnaires/${moldOrder.id}`)}
      className={`text-base w-full py-3 px-4 rounded-lg flex items-center justify-center bg-white border-2 ${borderColor} hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
      data-cy="fill-questionnaire-button"
    >
      {percentage === '100' ?
        <CheckCircle className="text-green-500 h-5 w-5 mr-2" /> :
        <ClipboardList className="h-5 w-5 mr-2" />}
      <span>กรอกแบบฟอร์ม {suffixString}</span>
    </button>
  );
};

export default FillQuestionnaireButton;